export default interface SubstrateClassReference {
  id?: number;
  substrateClassId: number;
  substrateClassName: string;
  substrateClassType: string | null;
  productReferenceId: string | null;
  productReferenceName: string | null;
}

export function labelOfReference(reference: SubstrateClassReference): string {
  if (reference.productReferenceName) {
    return reference.productReferenceName + (reference.substrateClassType ? ` (${reference.substrateClassType})` : "");
  }
  return reference.substrateClassName + (reference.substrateClassType ? ` (${reference.substrateClassType})` : "");
}
